export enum DialogButtons {
  Yes = 1,
  YesNo = 2,
  YesCancel = 3,
  YesNoCancel = 4
}
